import { Stack } from "../../../shared/ui/Stack/Stack";
import { Text } from "../../../shared/ui/Text/Text";
import styles from './Hygiene.module.scss';
import hygieneImg from '../../../shared/assets/photo/estetic/hygieneImg.png';
import hygieneImg_2x from '../../../shared/assets/photo/estetic/hygieneImg_2x.png';

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';


gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger); 

const Hygiene = () => {

    useGSAP(() => {     
        gsap.to(".hygieneImg", 
            {  
            duration: 2,          
            border: '2px solid #30AFB8',
            scrollTrigger: {
                trigger: ".hygieneImg"
        }});
    }, [])

    return ( 
        <div> 
            <Stack
                direction = 'column'
                gap = '16'
                justifyContent='justifyCenter'
                alignItems ='alignCenter'
                className={styles.container}>
                <Text
                    type='h3' 
                    size ='m'
                    className={styles.title}>
                        Профилактика в стоматологии чрезвычайно важна для сохранения здоровья 
                        полости рта и предотвращения стоматологических проблем в перспективе.
                </Text>
                <Text
                    type='h3' 
                    size ='m'
                    className={styles.title}>                        
                        Профилактическая стоматология рекомендована людям всех возрастов 
                        и использует различные методы защиты полости рта, такие как:  
                        чистка зубов, плановые стоматологические осмотры, применение фтора, 
                        герметизация фиссур.                        
                </Text>
                <Text
                    type='h3' 
                    size ='m'
                    className={styles.title}>                       
                        Профилактические меры и регулярные осмотры помогают
                        диагностировать проблемы с зубами на ранних стадиях и решить 
                        их более эффективно.
                </Text>
            </Stack>
            <Stack 
                justifyContent='justifyStart'
                alignItems ='alignCenter'
                className={styles.dark}>
                    <Stack
                        direction = 'column'
                        gap = '16'
                        justifyContent='justifyStart'
                        alignItems ='alignCenter'
                        className={styles.content}>   
                            <Text                             
                                size ='xl'
                                className={styles.textTitle}>
                                    Что такое чистка зубов AirFlow?                            
                            </Text>                       
                            <Text                             
                                size ='m'
                                className={styles.text}>                       
                                Чистка зубов AirFlow — это современная процедура
                                гигиены полости рта, которая использует комбинацию воздуха, 
                                воды и тонкого порошка для удаления пятен от кофе, чая и табака,  
                                налета и бактерий с ваших зубов.                           
                            </Text>

                            <Text                             
                                size ='m'
                                className={styles.text}>               
                                Преимуществом AirFlow является мягкая, неинвазивная чистка, бережное отношение 
                                к зубам и деснам.
                                Результат — более яркая и здоровая улыбка уже после одного посещения. 
                                Быстро и безболезненно!
                            </Text>
                            <Text                             
                                size ='m'
                                className={styles.text}>
                                    AirFlow — это отличная и обязательная подготовительная процедура перед отбеливанием зубов
                            </Text>
                    </Stack>
                        <div className={styles.imgContainer}>
                            <img className={`hygieneImg ${styles.picture}`} src={hygieneImg}
                                    srcSet={`${hygieneImg_2x} 2x`} alt="гигиена" />
                        </div>
            </Stack>
        </div>
    );
}
export default Hygiene;